import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

const Rooms = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const roomType = searchParams.get("roomType");

  const [RoomsData, setRoomsData] = useState([]); // room types
  const [RoomNumber, setRoomNumber] = useState([]); // all rooms

  // For each type → store selected room & slide index
  const [selectedRooms, setSelectedRooms] = useState({
    standard: null,
    deluxe: null,
    premium: null,
  });
  const [slideIndexes, setSlideIndexes] = useState({
    standard: 0,
    deluxe: 0,
    premium: 0,
  });

  // Fetch room types
  useEffect(() => {
    axios
      .get("https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_all_room_types")
      .then((res) => setRoomsData(res.data.data))
      .catch(console.error);
  }, []);

  // Fetch all rooms
  useEffect(() => {
    axios
      .get("https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/room_number_list")
      .then((res) => {
        setRoomNumber(res.data.data);

        // Set first room as default for each type
        const standardRooms = res.data.data.filter((r) => r.room_type_id === "2");
        const deluxeRooms = res.data.data.filter((r) => r.room_type_id === "3");
        const premiumRooms = res.data.data.filter((r) => r.room_type_id === "4");

        setSelectedRooms({
          standard: standardRooms[0] || null,
          deluxe: deluxeRooms[0] || null,
          premium: premiumRooms[0] || null,
        });
      })
      .catch(console.error);
  }, []);

  // Scroll to section based on query param
  useEffect(() => {
    if (!roomType) return;
    const sectionId = `${roomType}-section`;
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [roomType]);

  const handleRoomSelect = (type, room) => {
    setSelectedRooms((prev) => ({ ...prev, [type]: room }));
    setSlideIndexes((prev) => ({ ...prev, [type]: 0 }));
  };

  const renderRoomTypeSection = (type) => {
    const typeData = RoomsData.find((r) => r.room_type_id === type.id);
    const roomsOfType = RoomNumber.filter((r) => r.room_type_id === type.id);
    const selectedRoom = selectedRooms[type.slug];
    const slideIndex = slideIndexes[type.slug];

    return ( 
      <div className="row" id={`${type.slug}-section`} style={{ marginBottom: "40px" }}>
        {/* Room Type Info */}
        <div className="col-lg-6 room-short-detail">
          {typeData && (
            <>
              <h1 style={{fontSize:"40px"}}>{typeData.room_type_name}</h1>
              <p>{typeData.room_desp}</p>
            </>
          )}

          {/* Room Numbers */}
          <h5 style={{ margin: "10px 0" }}>{t("roon-no")}:</h5>
          <div className="room-numbers-section">
            {roomsOfType.map((room) => (
              <span key={room.room_id} onClick={() => handleRoomSelect(type.slug, room)}>
                {room.room_number}
              </span>
            ))}
          </div>
        </div>

        {/* Image Slider */}
        <div className="col-lg-6 my-rooms">
          {selectedRoom && (
            <>
              <div className="mySlides">
                <div className="numbertext">
                  {slideIndex + 1} / {selectedRoom.room_image.length}
                </div>
                <img
                  src={`https://cyberathon.com/silverapartment/${selectedRoom.room_image[slideIndex]}`}
                  style={{ width: "100%" }}
                  loading="lazy"
                  alt={`${t("room")} ${selectedRoom.room_number} ${t("view")} ${slideIndex + 1}`}
                />
              </div>

              {/* Prev / Next */}
              <a
                className="prev"
                onClick={() =>
                  setSlideIndexes((prev) => ({
                    ...prev,
                    [type.slug]:
                      prev[type.slug] === 0
                        ? selectedRoom.room_image.length - 1
                        : prev[type.slug] - 1,
                  }))
                }
              >
                ❮
              </a>
              <a
                className="next"
                onClick={() =>
                  setSlideIndexes((prev) => ({
                    ...prev,
                    [type.slug]:
                      prev[type.slug] === selectedRoom.room_image.length - 1
                        ? 0
                        : prev[type.slug] + 1,
                  }))
                }
              >
                ❯
              </a>

              {/* Thumbnails */}
              <div className="row slider-map">
                {selectedRoom.room_image.map((img, index) => (
                  <div className="column" key={index}>
                    <img
                      className={`demo cursor ${slideIndex === index ? "active" : ""}`}
                      src={`https://cyberathon.com/silverapartment/${img}`}
                      alt={`${t("room")} ${selectedRoom.room_number} ${t("view")} ${index + 1}`}
                      style={{ width: "100%", height: "50px" }}
                      loading="lazy"
                      onClick={() =>
                        setSlideIndexes((prev) => ({ ...prev, [type.slug]: index }))
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Booking Button */}
              <div className="booking-btn">
                <Link
                  to="/booking"
                  className="bk-btn"
                  state={{
                    roomNumber: selectedRoom.room_number,
                    roomType: selectedRoom.room_type_name,
                  }}
                >
                  {t("book_now")}
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <section className="rooms-section container">
      {renderRoomTypeSection({ id: "2", slug: "standard" })}
      {renderRoomTypeSection({ id: "3", slug: "deluxe" })}
      {renderRoomTypeSection({ id: "4", slug: "premium" })}
    </section>
  );
};

export default Rooms;
